import { s } from "@kosmod/pancake";

import { defineTool } from "./define";
import { TheatrePosition } from "../position";
import { TerrainCanvasID } from "../scene";
import { TerrainBrushID } from "../terrainBrush";

export const terrain = {
  paint: {
    brush: defineTool({
      key: 'terrain:paint',
      state: s.o({
        start: s.optional(TheatrePosition.def),
        part: s.lu(['wall', 'floor']),
        brush: s.optional(TerrainBrushID),
      }),
    }),
  }
}
